import { z } from 'zod';

export const APP_ROLES = [
  'admin',
  'talent_manager',
  'content_strategist',
  'account_executive',
  'finance',
  'account_manager',
] as const;

export const createOrganizationSchema = z.object({
  name: z.string().min(2, 'Organization name must be at least 2 characters').max(100),
  organizationType: z.enum(['agency', 'brand']),
});

export type CreateOrganizationFormValues = z.infer<typeof createOrganizationSchema>;

export const inviteUserSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  role: z.enum(APP_ROLES),
});

export type InviteUserFormValues = z.infer<typeof inviteUserSchema>;

export const generalSettingsSchema = z.object({
  name: z.string().min(2, 'Organization name must be at least 2 characters'),
  slug: z.string().min(2).regex(/^[a-z0-9-]+$/, 'Slug can only contain lowercase letters, numbers, and hyphens'),
  organizationType: z.enum(['agency', 'brand']).optional(),
  timezone: z.string().optional(),
  currency: z.string().optional(),
});

export type GeneralSettingsFormValues = z.infer<typeof generalSettingsSchema>;
